export default __webpack_public_path__ + "static/media/tn.da51a28c.png";